import styled from 'styled-components';

//helpers
import {borderRadius, cardShadowCss} from 'styles/vars';
import {commonPalette, checklistColors} from 'styles/palette';

//components
import Link from 'components/Link';

import {
  StepContentDesktop as $StepContentDesktop,
  StepContentMobile as $StepContentMobile
} from 'components/StepContent';
import {StepNumberDesktop as $StepNumberDesktop, StepNumberMobile as $StepNumberMobile} from 'components/StepNumber';
import Icon from 'components/Icon';

export const StepOverviewCardStatic = styled.div`
  position: relative;
  display: block;
  height: 100%;
  width: 100%;
`;

export const StepOverviewCardLink = StepOverviewCardStatic.withComponent(Link);

export const Content = styled.div`
  ${p => cardShadowCss(p.device === 'desktop' && p.isLink)};
  background: #fff;
  border-radius: ${p => borderRadius[p.device]}px;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const StepContentDesktop = styled($StepContentDesktop)`
  margin: 0.5rem 1rem 0.75rem 1rem;
  max-height: 4.5rem;
`;

export const StepContentMobile = styled($StepContentMobile)`
  margin: 0.5rem 0.75rem 0.5rem 0.75rem;
  max-height: 3.5rem;
`;

export const StepNumberDesktop = styled($StepNumberDesktop)`
  left: 0;
  position: absolute;
  top: 1rem;
  left: 0;
  transform: translateX(-50%);
  z-index: 100;
`;

export const StepNumberMobile = StepNumberDesktop.withComponent($StepNumberMobile);

export const StatusIcons = styled.div`
  display: flex;
  padding: 0px 12px 10px;
`;

export const baseIcon = `
  width: 15px;
  height: 15px;
  margin-right: 8px;
  border-radius: 3px;
  margin-top: 8px;
`;

export const CheckedStatus = styled.div`
  ${baseIcon}
  background: ${checklistColors.green};
`;

export const UncheckedStatus = styled.div`
  ${baseIcon}
  background: ${checklistColors.red};
`;

export const SkippedStatus = styled.div`
  ${baseIcon}
  border: 1px solid ${commonPalette.borderGrey};
`;

export const AddDetailsIcon = styled(Icon).attrs({
  name: 'add-details'
})`
  ${baseIcon}
  color: #0172CB;
`;

export const ReportIssueIcon = styled(Icon).attrs({
  name: 'report-issue'
})`
  ${baseIcon}
  color: #F31414;
`;

export const StepContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const baseIconScoring = `
padding: 4px;
width: 23px;
height: 23px;
margin-right: 4px;
border-radius: 3px;
margin-top: 8px;
color: white;
background-color: #000000;
display: flex;
justify-content: center;
align-items: center;
flex-shrink: 0;
@media (max-width: 800px) {
  width: 20px;
  height: 20px;
  margin-right: 1px;
}
`;

export const AddDetailsIconScoring = styled(Icon).attrs({
  name: 'add-details'
})`
  ${baseIconScoring}
`;

export const ReportIssueIconScoring = styled(Icon).attrs({
  name: 'report-issue'
})`
  ${baseIconScoring}
`;
export const IconWrapper = styled.div`
  display: inline-flex;
  padding: 4px;
`;
export const StyledIconsWrapper = styled.div`
  right: 0;
  position: absolute;
  z-index: 1000;
`;
